export enum TermsAndConditionsDisplayType {
    /** No T&Cs */
    None = 0,
    /** Text T&Cs displayed on site */
    Text = 1,
    /** External T&Cs */
    Url = 2,
  }